/* import __COLOCATED_TEMPLATE__ from './multi-payment-select-modal.hbs'; */
import { convertDateToDateTime } from '@banking/ui/components/banking/activity/date-filter';
import BalanceReporterActivity from '@banking/ui/utils/activity/balance-reporter-activity';
import { formatActivityDetails } from '@banking/ui/utils/activity/detail/formatter';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { equal, readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { BalanceReportItemTypeCategory } from '@square/dashboard-protos/models/squareup/balancereporter/model';
import { OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import moment from 'moment';
const CONFIG = {
  PAYMENTS_FROM_X_DAYS_AGO: 60,
  PAGINATION_SIZE: 20,
  MAX_SELECTED_PAYMENTS: 10
};

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  balanceReporterApi: service(),
  intl: service(),
  sentry: service(),
  toasterService: service('market-toasts'),
  activity: null,
  activitiesApi: null,
  additionalPayments: null,
  beginTime: moment().subtract(CONFIG.PAYMENTS_FROM_X_DAYS_AGO, 'days'),
  endTime: moment(),
  existingDisputes: null,
  isOriginalPaymentSelected: null,
  query: null,
  tempAdditionalPayments: null,
  tempIsOriginalPaymentSelected: null,
  unitToken: null,
  activityToken: readOnly('activity.activityToken'),
  isLoading: false,
  noPaymentsSelected: equal('totalSelectedPayments', 0),
  paginationToken: null,
  reachedMaxSelectedPayments: equal('totalSelectedPayments', CONFIG.MAX_SELECTED_PAYMENTS),
  disableOriginalPayment: computed('tempIsOriginalPaymentSelected', 'reachedMaxSelectedPayments', function () {
    return !this.tempIsOriginalPaymentSelected && this.reachedMaxSelectedPayments;
  }),
  disputablePayments: computed(function () {
    return [];
  }),
  paymentsSelectedDesc: computed('totalSelectedPayments', function () {
    return this.intl.t('disputes.squareCardClaims.multiPaymentSelectModal.totalSelectedOfMax', {
      count: this.totalSelectedPayments,
      maxCount: CONFIG.MAX_SELECTED_PAYMENTS
    });
  }),
  totalSelectedPayments: computed('tempIsOriginalPaymentSelected', 'tempAdditionalPayments.length', function () {
    return (this.tempIsOriginalPaymentSelected ? 1 : 0) + (this.tempAdditionalPayments || []).length;
  }),
  init(...args) {
    this._super(...args);
    this.setProperties({
      tempAdditionalPayments: [],
      tempIsOriginalPaymentSelected: this.isOriginalPaymentSelected,
      isLoading: true
    });
    const activitiesApi = new BalanceReporterActivity(this.balanceReporterApi, detail => formatActivityDetails(detail, this.intl, this.sentry));
    this.set('activitiesApi', activitiesApi);
    this.getDisputedPayments(null);
  },
  didInsertElement(...args) {
    this._super(...args);
    if (this.additionalPayments) {
      this.setProperties({
        tempAdditionalPayments: this.additionalPayments.map(payment => {
          // Shallow copy
          return {
            ...payment
          };
        })
      });
    }
  },
  getDisputedPayments(batchToken) {
    this.activitiesApi.getActivities({
      activityOwners: [{
        id: this.unitToken,
        type: OwnerType.UNIT
      }],
      selectedTypeCategory: {
        value: [BalanceReportItemTypeCategory.CARD_SPEND]
      },
      startAt: convertDateToDateTime(this.beginTime.toDate(), true),
      endAt: convertDateToDateTime(this.endTime.toDate(), false),
      excludeNonDisputable: true
    }, 'completed', {
      batchSize: CONFIG.PAGINATION_SIZE,
      batchToken
    }).then(response => {
      const disputablePayments = this.filterPayments(response.activities);
      this.setSelectedStateForEachPayment(disputablePayments);
      this.setProperties({
        disputablePayments: [...this.disputablePayments, ...disputablePayments],
        paginationToken: response.paginationToken,
        isLoading: false
      });
    }).catch(() => {
      this.toasterService.warning(this.intl.t('disputes.squareCardClaims.multiPaymentSelectModal.loadError'), {
        persistent: false,
        showDismiss: false
      });
    });
  },
  // Filter activities that are:
  // (1) Not the original payment selected
  // (2) In the settled state
  // (3) Not already disputed
  filterPayments(unifiedActivities) {
    return unifiedActivities.filter(unifiedActivity => unifiedActivity.id !== this.activity.id);
  },
  // When a user reopens the modal, payments that were
  // previously saved are instantiated as new objects. We
  // need to modify these new objects to the selected state
  setSelectedStateForEachPayment(unifiedActivities) {
    const additionalPaymentsSet = new Set();
    if (this.additionalPayments) {
      this.additionalPayments.forEach(additionalPayment => {
        additionalPaymentsSet.add(additionalPayment.id || additionalPayment.activityToken);
      });
    }
    unifiedActivities.forEach(unifiedActivity => {
      additionalPaymentsSet.has(unifiedActivity.id || unifiedActivity.activityToken) ? unifiedActivity.selected = true : unifiedActivity.selected = false;
    });
  },
  additionalPaymentSelected(payment) {
    let savedPayment;
    if (payment.id) {
      savedPayment = this.tempAdditionalPayments.findBy('id', payment.id);
    } else {
      savedPayment = this.tempAdditionalPayments.findBy('activityToken', payment.activityToken);
    }
    savedPayment ? this.tempAdditionalPayments.removeObject(savedPayment) : this.tempAdditionalPayments.pushObject(payment);
  },
  toggleOriginalPaymentSelected() {
    this.setProperties({
      tempIsOriginalPaymentSelected: !this.tempIsOriginalPaymentSelected
    });
  },
  // eslint-disable-next-line ember/no-actions-hash
  actions: {
    loadAdditionalPayments() {
      if (this.paginationToken) {
        this.set('isLoading', true);
        this.getDisputedPayments(this.paginationToken);
      }
    },
    submit() {
      this.saveOriginalPaymentSelection(this.tempIsOriginalPaymentSelected);
      this.tempAdditionalPayments === null || this.tempAdditionalPayments.length === 0 ? this.saveAdditionalPayments(null) : this.saveAdditionalPayments(this.tempAdditionalPayments);
      this.close();
    }
  }
});